// Snakes card game data - ranked by popularity/recognition
export const SNAKES_CARDS = [
  { id: 1, name: "King Cobra", rank: 1, image: "/images/snakes/snakes_1.jpg" },
  { id: 2, name: "Python", rank: 2, image: "/images/snakes/snakes_2.jpg" },
  { id: 3, name: "Anaconda", rank: 3, image: "/images/snakes/snakes_3.jpg" },
  { id: 4, name: "Rattlesnake", rank: 4, image: "/images/snakes/snakes_4.jpg" },
  { id: 5, name: "Boa Constrictor", rank: 5, image: "/images/snakes/snakes_5.jpg" },
  { id: 6, name: "Black Mamba", rank: 6, image: "/images/snakes/snakes_6.jpg" },
  { id: 7, name: "Coral Snake", rank: 7, image: "/images/snakes/snakes_7.jpg" },
  { id: 8, name: "Copperhead", rank: 8, image: "/images/snakes/snakes_8.jpg" },
  { id: 9, name: "Garter Snake", rank: 9, image: "/images/snakes/snakes_9.jpg" },
  { id: 10, name: "Cottonmouth", rank: 10, image: "/images/snakes/snakes_10.jpg" },
  { id: 11, name: "Corn Snake", rank: 11, image: "/images/snakes/snakes_11.jpg" },
  { id: 12, name: "Ball Python", rank: 12, image: "/images/snakes/snakes_12.jpg" },
  { id: 13, name: "Green Tree Python", rank: 13, image: "/images/snakes/snakes_13.jpg" },
  { id: 14, name: "Milk Snake", rank: 14, image: "/images/snakes/snakes_14.jpg" },
  { id: 15, name: "King Snake", rank: 15, image: "/images/snakes/snakes_15.jpg" },
  { id: 16, name: "Viper", rank: 16, image: "/images/snakes/snakes_16.jpg" },
  { id: 17, name: "Taipan", rank: 17, image: "/images/snakes/snakes_17.jpg" },
  { id: 18, name: "Eastern Diamondback", rank: 18, image: "/images/snakes/snakes_18.jpg" },
  { id: 19, name: "Burmese Python", rank: 19, image: "/images/snakes/snakes_19.jpg" },
  { id: 20, name: "Reticulated Python", rank: 20, image: "/images/snakes/snakes_20.jpg" },
  { id: 21, name: "Sea Snake", rank: 21, image: "/images/snakes/snakes_21.jpg" },
  { id: 22, name: "Asp", rank: 22, image: "/images/snakes/snakes_22.jpg" },
  { id: 23, name: "Sidewinder", rank: 23, image: "/images/snakes/snakes_23.jpg" },
  { id: 24, name: "Hognose Snake", rank: 24, image: "/images/snakes/snakes_24.jpg" },
  { id: 25, name: "Timber Rattlesnake", rank: 25, image: "/images/snakes/snakes_25.jpg" },
  { id: 26, name: "Bull Snake", rank: 26, image: "/images/snakes/snakes_26.jpg" },
  { id: 27, name: "Indigo Snake", rank: 27, image: "/images/snakes/snakes_27.jpg" },
  { id: 28, name: "Fer-de-Lance", rank: 28, image: "/images/snakes/snakes_28.jpg" },
  { id: 29, name: "Boomslang", rank: 29, image: "/images/snakes/snakes_29.jpg" },
  { id: 30, name: "Rough Green Snake", rank: 30, image: "/images/snakes/snakes_30.jpg" }
];
